import React from "react";
import { Moon, Sun } from "lucide-react";

export const useTheme = () => {
  const [dark, setDark] = React.useState(() => localStorage.getItem("theme") === "dark");
  React.useEffect(() => {
    const root = document.documentElement;
    if (dark) { root.classList.add("dark"); localStorage.setItem("theme", "dark"); }
    else { root.classList.remove("dark"); localStorage.setItem("theme", "light"); }
  }, [dark]);
  return { dark, toggle: () => setDark((d) => !d) };
};

export const ThemeToggle = () => {
  const { dark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      className="h-9 w-9 flex items-center justify-center rounded-xl border border-border bg-card hover:bg-accent transition-colors"
      aria-label="Alternar tema"
    >
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};
